(function () {
    'use strict';

    var app = angular.module('app');

    // Collect the routes
    app.constant('routes', getRoutes());

    // Configure the routes and route resolvers
    app.config(['$routeProvider', 'routes', routeConfigurator]);
    function routeConfigurator($routeProvider, routes) {
        routes.forEach(function (r) {
            $routeProvider.when(r.url, r.config);
        });
        $routeProvider.otherwise({ redirectTo: '/' });

        //console.info('routeConfigurator', $routeProvider );
    }

    // Define the routes 
    function getRoutes() {
        return [
            {
                url: '/',
                config: {
                    title: 'dashboard',
                    templateUrl: '/app/dashboard/dashboard_Resp_OIF.html?version=56' //dashboard_User.html?version=56'
                }
            },
            {
                url: '/dashboard_Super',
                config: {
                    title: 'dashboard',
                    templateUrl: '/app/dashboard/dashboard_Super.html?version=56'
                }
            },
            {
                url: '/dashboard_Resp_OIF',
                config: {
                    title: 'dashboard',
                    templateUrl: '/app/dashboard/dashboard_Resp_OIF.html?version=56'
                }
            },
            {
                url: '/dashboard_Resp_CPI',
                config: {
                    title: 'dashboard',
                    templateUrl: '/app/dashboard/dashboard_Resp_CPI.html?version=56'
                }
            },
            {
                url: '/dashboard_Segr_CPI',
                config: {
                    title: 'dashboard',
                    templateUrl: '/app/dashboard/dashboard_Segr_CPI.html?version=56'
                }
            },
            {
                url: '/dashboard_Promotore',
                config: {
                    title: 'dashboard',
                    templateUrl: '/app/dashboard/dashboard_Promotore.html?version=56'
                }
            },
            {
                url: '/dashboard_APL',
                config: {
                    title: 'dashboard',
                    templateUrl: '/app/dashboard/dashboard_APL.html?version=56'
                }
            }, {
                url: '/dashboard_UMC',
                config: {
                    title: 'dashboard',
                    templateUrl: '/app/dashboard/dashboard_UMC.html?version=56'
                }
            },
            {
                url: '/dashboard_GUEST',
                config: {
                    title: 'dashboard',
                    templateUrl: '/app/dashboard/dashboard_GUEST.html?version=56'
                }
            },
            {
                url: '/dashboard_MONITOR',
                config: {
                    title: 'dashboard',
                    templateUrl: '/app/dashboard/dashboard_MONITOR.html?version=56'
                }
            },
            {
                url: '/dashboard_Resp_ACCR',
                config: {
                    title: 'dashboard',
                    templateUrl: '/app/dashboard/dashboard_Resp_ACCR.html?version=56'
                }
            },
            {
                url: '/dashboard_Resp_ADES',
                config: {
                    title: 'dashboard',
                    templateUrl: '/app/dashboard/dashboard_Resp_ADES.html?version=56'
                }
            },
            {
                url: '/dashboard_Ospitante',
                config: {
                    title: 'dashboard',
                    templateUrl: '/app/dashboard/dashboard_Ospitante.html?version=56'
                }
            },
            //DESTINATARIO DIRETTO
            {
                url: '/destinatariodiretto',
                config: {
                    title: 'destinataridiretti',
                    templateUrl: '/app/destinatariodiretto/destinataridiretti.html?version=56'
                }
            }, {
                url: '/destinatariodiretto/:DestinatarioDirettoId',
                config: {
                    title: 'destinatariodirettoDetail',
                    templateUrl: '/app/destinatariodiretto/destinataridiretti.html?version=56'
                }
            },
            //ACCREDITAMENTO
            {
                url: '/accreditamento',
                config: {
                    title: 'accreditamenti',
                    templateUrl: '/app/accreditamento/accreditamenti.html?version=56'
                }
            }, {
                url: '/accreditamento/:AccreditamentoId',
                config: {
                    title: 'accreditamentoDetail',
                    templateUrl: '/app/accreditamento/accreditamenti.html?version=56'
                }
            },
            //DOMANDA DI ADESIONE
            {
                url: '/domandeAdesione',
                config: {
                    title: 'domandeAdesione',
                    templateUrl: '/app/domandaAdesione/domandeAdesione.html?version=56'
                }
            }, {
                url: '/domandaAdesione/:domandaAdesioneId',
                config: {
                    title: 'domandaAdesioneDetail',
                    templateUrl: '/app/domandaAdesione/domandeAdesione.html?version=56'
                }
            },
            //OMLS
            {
                url: '/omls',
                config: {
                    title: 'omls',
                    templateUrl: '/app/omls/omls.html?version=56'
                }
            }, {
                url: '/omls/:OMLSId',
                config: {
                    title: 'omlsDetail',
                    templateUrl: '/app/omls/omls.html?version=56'
                }
            },
            //NOTIFICATION
            {
                url: '/notifications',
                config: {
                    title: 'notifications',
                    templateUrl: '/app/notification/notifications.html?version=56'
                }
            }, {
                url: '/notifications/:NotificationId',
                config: {
                    title: 'notificationDetail',
                    templateUrl: '/app/notification/notifications.html?version=56'
                }
            },
            //DOWNLOAD
            {
                url: '/downloads',
                config: {
                    title: 'downloads',
                    templateUrl: '/app/download/downloads.html?version=56'
                }
            }, {
                url: '/downloads/:DownloadId',
                config: {
                    title: 'downloadDetail',
                    templateUrl: '/app/download/downloads.html?version=56'
                }
            },
            //TUTOR
            {
                url: '/tutor',
                config: {
                    title: 'tutor',
                    templateUrl: '/app/tutor/tutor.html?version=56'
                }
            }, {
                url: '/tutor/:TUTORId',
                config: {
                    title: 'tutorDetail',
                    templateUrl: '/app/tutor/tutor.html?version=56'
                }
            },
            //CORSO
            {
                url: '/corso',
                config: {
                    title: 'corsi',
                    templateUrl: '/app/corso/corsi.html?version=56'
                }
            },

            {
                url: '/corso/:CorsoId',
                config: {
                    title: 'corso',
                    templateUrl: '/app/corso/corsi.html?version=56'
                }
            },
            //ORIENTAMENTO
            {
                url: '/orientamento',
                config: {
                    title: 'orientamenti',
                    templateUrl: '/app/orientamento/orientamenti.html?version=56'
                }
            },

            {
                url: '/orientamento/:OrientamentoId',
                config: {
                    title: 'orientamento',
                    templateUrl: '/app/orientamento/orientamenti.html?version=56'
                }
            },
            //RICOLLOCAZIONE
            {
                url: '/ricollocazione',
                config: {
                    title: 'ricollocazioni',
                    templateUrl: '/app/ricollocazione/ricollocazioni.html?version=56'
                }
            },

            {
                url: '/ricollocazione/:RicollocazioneId',
                config: {
                    title: 'ricollocazione',
                    templateUrl: '/app/ricollocazione/ricollocazioni.html?version=56'
                }
            },
            //SEDE
            {
                url: '/sede',
                config: {
                    title: 'sedi',
                    templateUrl: '/app/sede/sedi.html?version=56'
                }
            }, {
                url: '/sede/:SedeId',
                config: {
                    title: 'sedeDetail',
                    templateUrl: '/app/sede/sedi.html?version=56'
                }
            },
            //ISTITUTO
            {
                url: '/istituto',
                config: {
                    title: 'istituti',
                    templateUrl: '/app/istituto/istituti.html?version=56'
                }
            }, {
                url: '/istituto/:IstitutoId',
                config: {
                    title: 'istitutoDetail',
                    templateUrl: '/app/istituto/istituti.html?version=56'
                }
            },
            //CLASSE
            {
                url: '/classe',
                config: {
                    title: 'classi',
                    templateUrl: '/app/classe/classi.html?version=56'
                }
            },
            {
                url: '/classe/:ClasseId',
                config: {
                    title: 'classeDetail',
                    templateUrl: '/app/classe/classi.html?version=56'
                }
            },
            //STUDENTE
            {
                url: '/studente',
                config: {
                    title: 'studenti',
                    templateUrl: '/app/studente/studenti.html?version=56'
                }
            }, {
                url: '/studente/:StudenteId',
                config: {
                    title: 'studenteDetail',
                    templateUrl: '/app/studente/studenti.html?version=56'
                }
            },
            //DOCENTE
            {
                url: '/docente',
                config: {
                    title: 'docenti',
                    templateUrl: '/app/docente/docenti.html?version=56'
                }
            }, {
                url: '/docente?ProfiloId=0&id=:docenteId',
                config: {
                    title: 'docenteDetail',
                    templateUrl: '/app/docente/docenti.html?version=56'
                }
            },
            //DOCENZA
            {
                url: '/docenza',
                config: {
                    title: 'docenza',
                    templateUrl: '/app/docenza/docenze.html?version=56'
                }
            }, {
                url: '/docenza/:DocenzaId',
                config: {
                    title: 'docenzaDetail',
                    templateUrl: '/app/docenza/docenzaDetail.html?version=56'
                }
            },
            //TICKET
            {
                url: '/ticket',
                config: {
                    title: 'ticket',
                    templateUrl: '/app/ticket/ticket.html?version=56'
                }
            },
            {
                url: '/ticket/:TicketId',
                config: {
                    title: 'ticketDetail',
                    templateUrl: '/app/ticket/ticket.html?version=56'
                }
            },
            //INCARICO
            {
                url: '/incarico',
                config: {
                    title: 'incarichi',
                    templateUrl: '/app/incarico/incarichi.html?version=56'
                }
            }, {
                url: '/incarico/:IncaricoId',
                config: {
                    title: 'incaricoDetail',
                    templateUrl: '/app/incarico/incaricoDetail.html?version=56'
                }
            },
            //LEZIONE
            {
                url: '/lezione',
                config: {
                    title: 'lezioni',
                    templateUrl: '/app/lezione/lezioni.html?version=56'
                }
            }, {
                url: '/lezione/:LezioneId',
                config: {
                    title: 'lezioneDetail',
                    templateUrl: '/app/lezione/lezioneDetail.html?version=56'
                }
            },
            //REGISTRO ATTIVITA
            {
                url: '/regAttivita',
                config: {
                    title: 'regAttivita',
                    templateUrl: '/app/regAttivita/regAttivita.html?version=56'
                }
            }, {
                url: '/regAttivita/:regAttivitaId',
                config: {
                    title: 'regAttivitaDetail',
                    templateUrl: '/app/regAttivita/regAttivitaDetail.html?version=56'
                }
            },
            //NEWSLETTER
            {
                url: '/newsletter',
                config: {
                    title: 'newsletter',
                    templateUrl: '/app/newsletter/newsletter.html?version=56'
                }
            },
            //SIGNATURE
            {
                url: '/signature',
                config: {
                    title: 'signature',
                    templateUrl: '/app/signature/signature.html?version=56'
                }
            },
            //AZIENDA
            {
                url: '/azienda',
                config: {
                    title: 'aziende',
                    templateUrl: '/app/azienda/aziende.html?version=56'
                }
            },
            {
                url: '/azienda/:AziendaId',
                config: {
                    title: 'aziendaDetail',
                    templateUrl: '/app/azienda/aziende.html?version=56'
                }
            },
            //MY LOG
            {
                url: '/myLog',
                config: {
                    title: 'myLog',
                    templateUrl: '/app/myLog/myLogs.html?version=56'
                }
            }, {
                url: '/myLog/:MyLogId',
                config: {
                    title: 'mylogDetail',
                    templateUrl: '/app/myLog/myLogs.html?version=56'
                }
            },
            //TIROCINANTE
            /*{
            	url: '/tirocinante',
            	config: {
            		title: 'tirocinanti',
            		templateUrl: '/app/tirocinante/tirocinanti.html?version=56'
            	}
            }, {
            	url: '/tirocinante/:TirocinanteId',
            	config: {
            		title: 'tirocinanteDetail',
            		templateUrl: '/app/tirocinante/tirocinanti.html?version=56'
            	}
            },*/
            //TIROCINIO
            {
                url: '/tirocinio',
                config: {
                    title: 'tirocini',
                    templateUrl: '/app/tirocinio/tirocini.html?version=56'
                }
            }, {
                url: '/tirocinio/:TirocinioId',
                config: {
                    title: 'tirocinioDetail',
                    templateUrl: '/app/tirocinio/tirocini.html?version=56'
                }
            },
            //TIROCINIO LOGS
            {
                url: '/tirLog',
                config: {
                    title: 'tirLog',
                    templateUrl: '/app/tirLog/tirLogs.html?version=56'
                }
            }, {
                url: '/tirLog/:TirLogId',
                config: {
                    title: 'tirocinioDetail',
                    templateUrl: '/app/tirLog/tirLogs.html?version=56'
                }
            },
            //TIR RIMBORSO
            {
                url: '/tirRimborso',
                config: {
                    title: 'tirRimborso',
                    templateUrl: '/app/tirRimborso/tirRimborsi.html?version=56'
                }
            }, {
                url: '/tirRimborso/:TirRimborsoId',
                config: {
                    title: 'tirRimborsoDetail',
                    templateUrl: '/app/tirRimborso/tirRimborsi.html?version=56'
                }
            },
            //COLLOCAMENTO
            {
                url: '/collContratto',
                config: {
                    title: 'collContratti',
                    templateUrl: '/app/collContratto/collContratti.html?version=56'
                }
            }, {
                url: '/collContratto/:CollocamentoId',
                config: {
                    title: 'collocamentoDetail',
                    templateUrl: '/app/collContratto/collContratti.html?version=56'
                }
            },
            //COLLOCAMENTO RIMBORSO
            {
                url: '/collRimborso',
                config: {
                    title: 'collRimborsi',
                    templateUrl: '/app/collRimborso/collRimborsi.html?version=56'
                }
            },
            {
                url: '/collRimborso/:CollRimborsoId',
                config: {
                    title: 'collRimborso',
                    templateUrl: '/app/collRimborso/collRimborsi.html?version=56'
                }
            },
            //COLLOCAMENTO SERVIZIO
            {
                url: '/collServizio',
                config: {
                    title: 'collServizi',
                    templateUrl: '/app/collServizio/collServizi.html?version=56'
                }
            },
            {
                url: '/collServizio/:CollServizioId',
                config: {
                    title: 'collServizio',
                    templateUrl: '/app/collServizio/collServizi.html?version=56'
                }
            },
            //ISSUE-LOG
            {
                url: '/issueLog',
                config: {
                    title: 'issueLog',
                    templateUrl: '/app/issueLog/issuesLog.html?version=56'
                }
            }, {
                url: '/issueLog/:IssueLogId',
                config: {
                    title: 'issueLogDetail',
                    templateUrl: '/app/issueLog/issuesLog.html?version=56'
                }
            },


            //FAQ
            {
                url: '/faq',
                config: {
                    title: 'faq',
                    templateUrl: '/app/faq/faq.html?version=56'
                }
            },
            {
                url: '/faq/:faqId',
                config: {
                    title: 'faq',
                    templateUrl: '/app/faq/faq.html?version=56'
                }
            },
            {
                url: '/faqRead',
                config: {
                    title: 'faq',
                    templateUrl: '/app/faq/faqRead.html?version=56'
                }
            },
            //ATTACH
            {
                url: '/attach',
                config: {
                    title: 'attach',
                    templateUrl: '/app/attach/attach.html?version=56'
                }
            },
            {
                url: '/attach/:AttachId',
                config: {
                    title: 'attach',
                    templateUrl: '/app/attach/attach.html?version=56'
                }
            },
            //T_ATTACH
            {
                url: '/tAttach',
                config: {
                    title: 'tAttach',
                    templateUrl: '/app/tAttach/tAttach.html?version=56'
                }
            },
            {
                url: '/tAttach/:TAttachId',
                config: {
                    title: 'tAttach',
                    templateUrl: '/app/tAttach/tAttach.html?version=56'
                }
            },
            //RIMBORSO
            {
                url: '/rimborso',
                config: {
                    title: 'rimborsi',
                    templateUrl: '/app/rimborso/rimborsi.html?version=56'
                }
            },
            {
                url: '/rimborso/:RimborsoId',
                config: {
                    title: 'rimborso',
                    templateUrl: '/app/rimborso/rimborsi.html?version=56'
                }
            },
            //RIMBORSO SEGRETERIA
            {
                url: '/rimborsoSegr',
                config: {
                    title: 'rimborsi',
                    templateUrl: '/app/rimborsoSegr/rimborsi.html?version=56'
                }
            },
            {
                url: '/rimborsoSegr/:RimborsoId',
                config: {
                    title: 'rimborso',
                    templateUrl: '/app/rimborsoSegr/rimborsi.html?version=56'
                }
            },
            //RISORSA
            {
                url: '/risorsa',
                config: {
                    title: 'risorse',
                    templateUrl: '/app/risorsa/risorse.html?version=56'
                }
            }, {
                url: '/risorsa?ProfiloId=0&id=:RisorsaId',
                config: {
                    title: 'risorsaDetail',
                    templateUrl: '/app/risorsa/risorse.html?version=56'
                }
            },
            //CHECKLIST
            {
                url: '/checklist',
                config: {
                    title: 'checklist',
                    templateUrl: '/app/checklist/checklist.html?version=56'
                }
            }, {
                url: '/checklist/:ChecklistId',
                config: {
                    title: 'checklistDetail',
                    templateUrl: '/app/checklist/checklist.html?version=56'
                }
            },
            //USER
            {
                url: '/user',
                config: {
                    title: 'users',
                    templateUrl: '/app/user/users.html?version=56'
                }
            },
            {
                url: '/user/:UserId',
                config: {
                    title: 'userDetail',
                    templateUrl: '/app/user/users.html?version=56'
                }
            },
            //ROLES AUTHORIZATION
            {
                url: '/rolesAuthorization',
                config: {
                    title: 'rolesAuthorization',
                    templateUrl: '/app/rolesAuthorization/rolesAuthorization.html?version=56'
                }
            },
            {
                url: '/rolesAuthorization/:rolesAuthorizationId',
                config: {
                    title: 'rolesAuthorizationDetail',
                    templateUrl: '/app/rolesAuthorization/rolesAuthorization.html?version=56'
                }
            },
            //ROLES
            {
                url: '/roles',
                config: {
                    title: 'roles',
                    templateUrl: '/app/web_roles/roles.html?version=56'
                }
            },
            {
                url: '/roles/:rolesId',
                config: {
                    title: 'rolesDetail',
                    templateUrl: '/app/web_roles/roles.html?version=56'
                }
            },
            //AREAS
            {
                url: '/areas',
                config: {
                    title: 'areas',
                    templateUrl: '/app/web_areas/areas.html?version=56'
                }
            },
            {
                url: '/areas/:areaId',
                config: {
                    title: 'areaDetail',
                    templateUrl: '/app/web_areas/areas.html?version=56'
                }
            },
            //GRUPPO AMM
            {
                url: '/gruppoAmm',
                config: {
                    title: 'gruppiAmm',
                    templateUrl: '/app/gruppoAmm/gruppiAmm.html?version=56'
                }
            }, {
                url: '/gruppoAmm/:gruppoAmmId',
                config: {
                    title: 'gruppoAmmDetail',
                    templateUrl: '/app/gruppoAmm/gruppiAmm.html?version=56'
                }
            },
            //GRUPPO DID
            {
                url: '/gruppoDid',
                config: {
                    title: 'gruppiDid',
                    templateUrl: '/app/gruppoDid/gruppiDid.html?version=56'
                }
            }, {
                url: '/gruppoDid/:gruppoDidId',
                config: {
                    title: 'gruppoDidDetail',
                    templateUrl: '/app/gruppoDid/gruppiDid.html?version=56'
                }
            },
            //QUERY
            {
                url: '/query',
                config: {
                    title: 'gruppiDid',
                    templateUrl: '/app/query/query.html?version=56'
                }
            },
            //EDUP Question
            {
                url: '/EDUP_question',
                config: {
                    title: 'question',
                    templateUrl: '/app/EDUP_question/questions.html?version=56'
                }
            }, {
                url: '/EDUP_question/:questionId/:testId',
                config: {
                    title: 'questionDetail',
                    templateUrl: '/app/EDUP_question/questions.html?version=56'
                }
            },
            //EDUP Test
            {
                url: '/EDUP_test',
                config: {
                    title: 'test',
                    templateUrl: '/app/EDUP_test/tests.html?version=56'
                }
            }, {
                url: '/EDUP_test/:testId',
                config: {
                    title: 'testDetail',
                    templateUrl: '/app/EDUP_test/tests.html?version=56'
                }
            },
            //EDUP Session
            {
                url: '/EDUP_session',
                config: {
                    title: 'session',
                    templateUrl: '/app/EDUP_session/sessions.html?version=56'
                }
            }, {
                url: '/EDUP_session/:sessionId',
                config: {
                    title: 'sessionDetail',
                    templateUrl: '/app/EDUP_session/sessions.html?version=56'
                }
            },

            //Candidature - Accreditamenti
            {
                url: '/CNDAccreditamento',
                config: {
                    title: 'accreditamento',
                    templateUrl: '/app/CND_Accreditamento/cndAccreditamenti.html?version=56'
                }
            }, {
                url: '/CNDAccreditamento/:projectUID',
                config: {
                    title: 'accreditamentoDetail',
                    templateUrl: '/app/CND_Accreditamento/cndAccreditamenti.html?version=56'
                }
            }, {
                url: '/CNDAccreditamento/:projectUID/:accreditamentoUID',
                config: {
                    title: 'accreditamentoDetail',
                    templateUrl: '/app/CND_Accreditamento/cndAccreditamenti.html?version=56'
                }
            },
            //Candidature - Domanda
            {
                url: '/CNDDomanda',
                config: {
                    title: 'domanda',
                    templateUrl: '/app/CND_DomandaAdesione/cndDomandeAdesione.html?version=56'
                }
            }, {
                url: '/CNDDomanda/:projectUID',
                config: {
                    title: 'accreditamentoDetail',
                    templateUrl: '/app/CND_DomandaAdesione/cndDomandeAdesione.html?version=56'
                }
            }, {
                url: '/CNDDomanda/:projectUID/:domandaAdesioneUID',
                config: {
                    title: 'accreditamentoDetail',
                    templateUrl: '/app/CND_DomandaAdesione/cndDomandeAdesione.html?version=56'
                }
            }
            /*,
            //Candidature - Domanda - CV
            { 
                url: '/CNDCV',
                config: {
                    title: 'curriculumVitae',
                    templateUrl: '/app/CND_CV/curriculumVitae.html?version=56'
                }
            }, {
                url: '/CNDCV/:projectUID',
                config: {
                    title: 'curriculumVitaeDetail',
                    templateUrl: '/app/CND_CV/curriculumVitae.html?version=56'
                }
            }, {
                url: '/CNDCV/:projectUID/:domandaAdesioneUID',
                config: {
                    title: 'curriculumVitaeDetail',
                    templateUrl: '/app/CND_CV/curriculumVitae.html?version=56'
                }
            },*/
        ];
    }
})();